import i18next from 'i18next';

import { TEMPLATE_LANGUAGES, TEMPLATE_TYPES } from 'common/constants';

export const getLanguageOptions = () => {
    return [
        {
            disabled: true,
            label: i18next.t('Select a language'),
            value: '',
        },
        {
            label: i18next.t('Spanish'),
            value: TEMPLATE_LANGUAGES.ES_MX,
        },
        {
            label: i18next.t('English'),
            value: TEMPLATE_LANGUAGES.EN_US,
        },
    ];
};

export const getTypeOptions = () => {
    return [
        {
            disabled: true,
            label: i18next.t('Select a type'),
            value: '',
        },
        {
            label: i18next.t('Proposal'),
            value: TEMPLATE_TYPES.PROPOSAL_TYPE,
        },
        {
            label: 'BOM',
            value: TEMPLATE_TYPES.BOM_TYPE,
        },
        {
            label: i18next.t('System', { count: 2 }),
            value: TEMPLATE_TYPES.SYSTEM_TYPE,
        },
    ];
};
